<template>
  <img :src="parsePublicAssetsPath(spinner)" alt="Loading..." />
</template>

<script setup lang="ts">
import spinner from '@/assets/vonage-spinner.gif';
import parsePublicAssetsPath from '@/utils/parsePublicAssetsPath';
</script>
